import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=67be1039&scoped=true&"
import script from "./LocaleChanger.vue?vue&type=script&lang=js&"
export * from "./LocaleChanger.vue?vue&type=script&lang=js&"
import style0 from "./LocaleChanger.vue?vue&type=style&index=0&id=67be1039&prod&lang=scss&"
import style1 from "./LocaleChanger.vue?vue&type=style&index=1&id=67be1039&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be1039",
  null
  
)

export default component.exports